// extracted by mini-css-extract-plugin
module.exports = {"dialog":"DataDialog_dialog__1PTVF","appBar":"DataDialog_appBar__1ce2D","networkInfo":"DataDialog_networkInfo__PzqYq","buttonContainer":"DataDialog_buttonContainer__1RqGy"};